// vehicleService.js
import axios from 'axios';

const API_URL = '/api';

// Tüm araçları listele
export const getVehicles = async (filters = {}) => {
    try {
        const queryString = new URLSearchParams(filters).toString();
        const response = await axios.get(`${API_URL}/vehicles?${queryString}`);
        return response.data;
    } catch (error) {
        console.error('Araçları listeleme hatası:', error);
        throw error;
    }
};

// Kullanıcının kendi araçlarını getir
export const getMyVehicles = async () => {
    try {
        // DÜZELTME: Endpoint /my-vehicles değil, /my/vehicles olarak güncellendi
        const response = await axios.get(
            `${API_URL}/vehicles/my/vehicles`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Araçlarımı getirme hatası:', error);
        throw error;
    }
};

// Araç detaylarını ID'ye göre getir
// Araç detaylarını ID'ye göre getir
export const getVehicleById = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/vehicles/${id}`);

        // Yanıt başarılı ve araç verisi varsa, Cloudinary default resimlerini filtrele
        if (response.data && response.data.success && response.data.vehicle) {
            const vehicle = response.data.vehicle;

            // Cloudinary default URL'sini filtrele
            if (vehicle.images && Array.isArray(vehicle.images)) {
                vehicle.images = vehicle.images.filter(img =>
                    !img.includes('default_zxlbnq.webp'));
            }

            // imageUrl de Cloudinary default ise filtrele
            if (vehicle.imageUrl && vehicle.imageUrl.includes('default_zxlbnq.webp')) {
                // Varsayılan yerel resmi kullan
                vehicle.imageUrl = '/uploads/vehicles/default.jpg';
            }
        }

        console.log('API getVehicleById yanıtı:', response.data);
        return response.data;
    } catch (error) {
        console.error('Araç detaylarını alma hatası:', error);
        throw error;
    }
};

// Yeni araç oluştur
export const createVehicle = async (vehicleData) => {
    try {
        console.log('Gönderilecek araç verileri:', vehicleData);
        const response = await axios.post(
            `${API_URL}/vehicles`,
            vehicleData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        console.log('Araç oluşturma yanıtı:', response.data);
        return response.data;
    } catch (error) {
        console.error('Araç oluşturma hatası:', error);
        throw error;
    }
};

// Araç güncelle
// Araç güncelle
export const updateVehicle = async (id, vehicleData) => {
    try {
        console.log('Güncellenecek araç verileri:', vehicleData);
        console.log('Images dizisi:', vehicleData.images);

        // Cloudinary URL'lerini ve diğer URL'leri düzgün şekilde işle
        if (vehicleData.images && Array.isArray(vehicleData.images)) {
            vehicleData.images = vehicleData.images.map(img => {
                // Cloudinary URL'lerini olduğu gibi bırak
                if (img && img.includes('cloudinary.com')) {
                    return img;
                }
                // Tam URL'leri göreceli yollara dönüştür
                else if (img && img.includes('')) {
                    return img.replace('', '');
                }
                return img;
            });
        }

        // Ana resim URL'si için de aynı işlem
        if (vehicleData.imageUrl) {
            if (vehicleData.imageUrl.includes('cloudinary.com')) {
                // Cloudinary URL'si olduğu gibi kalsın
            }
            else if (vehicleData.imageUrl.includes('')) {
                vehicleData.imageUrl = vehicleData.imageUrl.replace('', '');
            }
        }

        console.log('Dönüştürülmüş images dizisi:', vehicleData.images);

        const response = await axios.put(
            `${API_URL}/vehicles/${id}`,
            vehicleData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        console.log('Araç güncelleme yanıtı:', response.data);
        return response.data;
    } catch (error) {
        console.error('Araç güncelleme hatası:', error);
        throw error;
    }
};

// Araç sil
export const deleteVehicle = async (id) => {
    try {
        const response = await axios.delete(
            `${API_URL}/vehicles/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Araç silme hatası:', error);
        throw error;
    }
};

// Kullanıcının favori araçlarını getir
export const getFavoriteVehicles = async () => {
    try {
        const response = await axios.get(
            `${API_URL}/vehicles/favorites`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Favori araçları alma hatası:', error);
        throw error;
    }
};

// Aracı favorilere ekle
export const addToFavorites = async (vehicleId) => {
    try {
        const response = await axios.post(
            `${API_URL}/vehicles/favorites/${vehicleId}`,
            {},
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Favorilere ekleme hatası:', error);
        throw error;
    }
};

// Aracı favorilerden çıkar
export const removeFromFavorites = async (vehicleId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/vehicles/favorites/${vehicleId}`,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Favorilerden çıkarma hatası:', error);
        throw error;
    }
};

export default {
    getVehicles,
    getMyVehicles,
    getVehicleById,
    createVehicle,
    updateVehicle,
    deleteVehicle,
    getFavoriteVehicles,
    addToFavorites,
    removeFromFavorites
};